import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase env vars not set — auth and cloud sync will be unavailable.');
}

export const supabase = supabaseUrl && supabaseAnonKey
  // PKCE returns `?code=` in the query string. The implicit flow returns tokens
  // in the URL hash, which HashRouter would treat as a route.
  ? createClient(supabaseUrl, supabaseAnonKey, { auth: { flowType: 'pkce' } })
  : null;

// Clean up old Express-era tokens
try {
  localStorage.removeItem('ultronic_token');
  localStorage.removeItem('ultronic_refresh_token');
} catch {
  // Storage unavailable (private mode or blocked): nothing to clean up.
}
